import { Box } from '@mui/material'
import { AttachmentPreviewIcon, fileTypeLabel, formatBytes } from '@/components/AiAskBar'
import Tooltip from '@/components/Tooltip'
import SentImageThumb from './SentImageThumb'
import styles from './index.module.scss'

export default function UserChatBubbleAttachmentChips({
  attachmentImageEntries,
  attachmentDocEntries,
  imageThumbSizeVariant,
  openSentImageGallery,
}) {
  return (
    <Box className={styles.attachmentsWrap}>
      {attachmentImageEntries.length > 0 ? (
        <Box className={styles.attachmentsImagesRow}>
          {attachmentImageEntries.map(({ file, originalIdx, imageIndex }) => (
            <SentImageThumb
              key={`att-img-${originalIdx}-${file.name}-${file.size}`}
              file={file}
              sizeVariant={imageThumbSizeVariant}
              onClick={() => openSentImageGallery(imageIndex)}
            />
          ))}
        </Box>
      ) : null}
      {attachmentDocEntries.length > 0 ? (
        <Box className={styles.attachmentsDocsRow}>
          {attachmentDocEntries.map(({ file, originalIdx }) => (
            <Box key={`att-doc-${originalIdx}-${file.name}-${file.size}`} className={styles.fileChip}>
              <Box className={styles.fileIconPreview} aria-hidden>
                <AttachmentPreviewIcon file={file} />
              </Box>
              <Tooltip text={file.name} placement="top" maxLines={2} bubbleMaxWidth="100px">
                <Box className={styles.fileMeta}>
                  <Box component="span" className={styles.fileName}>
                    {file.name}
                  </Box>
                  <Box component="span" className={styles.fileInfo}>
                    {fileTypeLabel(file)} {formatBytes(file.size)}
                  </Box>
                </Box>
              </Tooltip>
            </Box>
          ))}
        </Box>
      ) : null}
    </Box>
  )
}
